import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiConfig } from '@/config/api.config';
import { useAxiosAuth } from '@/hooks/useAxiosAuth';
import { UpdateSuperAdminBookingRequestDto } from '@/features/superAdmin/features/data/types/superAdmin-data.types';

export const useSuperAdminBookingMutationsApi = () => {
    const axiosInstance = useAxiosAuth();
    const queryClient = useQueryClient();

    const invalidateBookings = async (id?: string) => {
        await queryClient.invalidateQueries({
            queryKey: [ApiConfig.queries.superAdmin.data.bookings.queryKeys.list],
        });
        if (id) {
            await queryClient.invalidateQueries({
                queryKey: [ApiConfig.queries.superAdmin.data.bookings.queryKeys.detail, id],
            });
        }
    };

    const updateMutation = useMutation({
        mutationFn: async ({ id, body }: { id: string; body: UpdateSuperAdminBookingRequestDto }) => {
            await axiosInstance.put(
                `${ApiConfig.queries.superAdmin.data.bookings.endpoints.update}/${id}`,
                body,
            );
        },
        onSuccess: async (_data, variables) => {
            await invalidateBookings(variables.id);
        },
    });

    const deleteMutation = useMutation({
        mutationFn: async (id: string) => {
            await axiosInstance.delete(
                `${ApiConfig.queries.superAdmin.data.bookings.endpoints.delete}/${id}`,
            );
        },
        onSuccess: async (_data, id) => {
            await invalidateBookings(id);
        },
    });

    return { updateMutation, deleteMutation };
};
